export const MAX_CACHE_AGE = 15 * 1000 * 60; // 15 minutes

export const STAGECACHE_SET_FIELDS = 'STAGECACHE_SET_FIELDS';
